/**
 * Shared formatting utilities for EditorJS table tools
 */

export const formatCurrency = (value: number) => {
  if (typeof value !== "number" || isNaN(value)) return "$0"

  const absValue = Math.abs(value)
  const sign = value < 0 ? "-" : ""

  let displayValue: number
  let suffix: string

  if (absValue >= 1000000000) {
    displayValue = absValue / 1000000000
    suffix = "b"
  } else if (absValue >= 1000000) {
    displayValue = absValue / 1000000
    suffix = "m"
  } else if (absValue >= 1000) {
    displayValue = absValue / 1000
    suffix = "k"
  } else {
    displayValue = absValue
    suffix = ""
  }

  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: displayValue < 10 && suffix ? 1 : 0,
  }).format(displayValue)

  return sign + formatted + suffix
}

export const formatCurrencyInThousands = (value: number) => {
  if (typeof value !== "number" || isNaN(value)) return "$0k"

  const absValue = Math.abs(value)
  const sign = value < 0 ? "-" : ""

  // Display in thousands
  const displayValue = absValue / 1000

  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: displayValue < 10 ? 1 : 0,
  }).format(displayValue)

  return sign + formatted + "k"
}

export const formatPercent = (value: number) => {
  if (typeof value !== "number" || isNaN(value)) return "0.0%"
  return `${value.toFixed(1)}%`
}

export const formatRatio = (value: number) => {
  if (typeof value !== "number" || isNaN(value)) return "0.00x"
  return `${value.toFixed(2)}x`
}

// Abbreviate quarter labels for compact tables: "Q4 2021" -> "Q4'21"
export const formatCompactQuarter = (quarter: string): string =>
  quarter.replace(/^(Q\d+) \d{2}(\d{2})$/, "$1'$2")

export const formatAge = (value: number) => {
  if (typeof value !== "number" || isNaN(value)) return "0.0m"
  const months = value * 12
  return `${months.toFixed(1)}m`
}
